module.exports = __webpack_public_path__ + "flyer_background_bottles_003-a4b01682ca0f10d1f8403467f72f7a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_bottles_003.jpg
// module id = 1610
// module chunks = 1